import { Component, Inject, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CategoryService } from 'src/app/core/services/api/category.service';
import { Category } from 'src/app/core/contracts/models/category';
import { Swal2 } from 'src/app/core/utils/swal2.util';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-category-form',
  templateUrl: './category-form.component.html',
  styleUrls: ['./category-form.component.scss']
})
export class CategoryFormComponent implements OnInit {
  public loading:boolean = false;

  categoria: Category = {
    descripcion: null,
    idCategoriaPadre: null
  };

  myForm = this.formBuilder.group({
    descripcion: new FormControl<string|null>(null,[Validators.required]),
    idCategoriaPadre: new FormControl<number|null>(null)
  });

  title: string = 'Crear categoría';
  disabled: boolean = false;
  categorias: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private categoryService: CategoryService,
    public dialogRef: MatDialogRef<CategoryFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private swal: Swal2
  ) {
    if (data) {
      this.disabled = true;
      this.myForm.controls.descripcion.setValue(data.descripcion);
      this.myForm.controls.idCategoriaPadre.setValue(data.idCategoriaPadre);
      this.title = 'Editar categoría';
    }
  }

  ngOnInit(): void {
    this.categoryService.legacyGetAll().subscribe((response: any) => {
      const { categorias } = response;
      this.categorias = categorias;
    });
  }

  onSubmit() {
  
    this.categoria={
      descripcion:this.myForm.controls.descripcion.value,
      idCategoriaPadre:this.myForm.controls.idCategoriaPadre.value
    }
    
    let observable:Observable<any>|undefined = undefined;
    if (this.data) {
      this.categoria.id = this.data.id;
      observable=this.categoryService.update(this.categoria)
       
    } else {
     observable=this.categoryService.create(this.categoria)
    }
    this.loading = true;
    observable.subscribe((response: any) => {
      this.dialogRef.close(response);
      this.loading = false;
      this.swal.showToast(response.message, 'success')
    }, error => {
      if (error.status === 400) {
        this.errors(error);
      }
      this.loading = false;
    });
  }

  errors(error) {
    if (error.error.errors.descripcion) {
      this.swal.showToast(error.error.errors.descripcion[0], 'error')
    }
    if (error.error.errors.idCategoriaPadre) {
      this.swal.showToast(error.error.errors.idCategoriaPadre[0], 'error')
    }
  }
}
